export default "__VITE_ASSET__1JkLroj5__"